import { put } from '../../base';

import { Product } from './types-product';
import { ProductPayloadUpdate } from './types-product-update';

export function updateMerchantProduct(payload: ProductPayloadUpdate): Promise<Product> {
  const { productId, body } = payload;
  return put(`v5/merchant/products/${productId}`, { json: body }).json();
}
